import { render, staticRenderFns } from "./list_config_dataset_detail_list.vue?vue&type=template&id=fc9c1218"
import script from "./list_config_dataset_detail_list.vue?vue&type=script&lang=js"
export * from "./list_config_dataset_detail_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports